import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  SEND_OTP_REQUEST,
  MOBILE_NO_LOGIN_REQUEST,
  GOOGLE_LOGIN_REQUEST,
  FACEBOOK_LOGIN_REQUEST,
} from "./actionTypes";
import {
  sendOtpResponse,
  mobileNoLoginResponse,
  googleLoginResponse,
  facebookLoginResponse,
} from "./actions";

import { handleApiCallException } from "store/Shared/actions";

// AUTH related methods
import { invokeApi } from "../../../helpers/axiosHelper";

//If user is login then dispatch redux action's are directly from here.
function* sendOtp({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "POST", "/Account/SendOtp", data);
    yield put(sendOtpResponse(response, data.mobileNo));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* mobileNoLogin({ payload: { data } }) {
  try {
    const response = yield call(
      invokeApi,
      "POST",
      "/Account/MobileNoLogin",
      data
    );
    yield put(mobileNoLoginResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* googleLogin({ payload: { data } }) {
  try {
    const response = yield call(
      invokeApi,
      "POST",
      "/Account/GoogleLogin",
      data
    );
    yield put(googleLoginResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* facebookLogin({ payload: { data } }) {
  try {
    const response = yield call(
      invokeApi,
      "POST",
      "/Account/FacebookLogin",
      data
    );
    yield put(facebookLoginResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchUserLogin() {
  yield takeEvery(SEND_OTP_REQUEST, sendOtp);
  yield takeEvery(MOBILE_NO_LOGIN_REQUEST, mobileNoLogin);
  yield takeEvery(GOOGLE_LOGIN_REQUEST, googleLogin);
  yield takeEvery(FACEBOOK_LOGIN_REQUEST, facebookLogin);
}

function* loginSaga() {
  yield all([fork(watchUserLogin)]);
}

export default loginSaga;
